import React, { useState, useEffect } from 'react';

const CAMPI_BOTOX = [
    { key: 'frontale', label: 'Frontale' },
    { key: 'glabella', label: 'Glabella' },
    { key: 'sopracciglia', label: 'Sopracciglia' },
    { key: 'zampe_gallina', label: 'Zampe Gallina' },
    { key: 'lip_flip', label: 'Lip Flip' },
    { key: 'masseteri', label: 'Masseteri' },
    { key: 'mentale', label: 'Mentale' },
    { key: 'nasale', label: 'Nasale' },
    { key: 'platisma', label: 'Platisma' },
    { key: 'altro', label: 'Altro' }
];

const MappaBotox = ({ data, onChange, readOnly }) => {
    const [valori, setValori] = useState(data?.valori || {});
    const [punti, setPunti] = useState(data?.punti || []);

    useEffect(() => {
        if (data) {
            setValori(data.valori || {});
            setPunti(data.punti || []);
        }
    }, [data]);

    const handleImageClick = (e) => {
        if (readOnly) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        const newPunti = [...punti, { x, y, id: Date.now() }];
        setPunti(newPunti);
        if (onChange) onChange({ valori, punti: newPunti });
    };

    const handleRemovePunto = (id) => {
        if (readOnly) return;
        const newPunti = punti.filter(p => p.id !== id);
        setPunti(newPunti);
        if (onChange) onChange({ valori, punti: newPunti });
    };

    const handleValoreChange = (key, value) => {
        const newValori = { ...valori, [key]: value };
        setValori(newValori);
        if (onChange) onChange({ valori: newValori, punti });
    };

    const totale = CAMPI_BOTOX.reduce((sum, campo) => {
        return sum + (parseFloat(valori[campo.key]) || 0);
    }, 0);

    return (
        <div className="mappa-botox">
            <div className="botox-image-container" onClick={handleImageClick}>
                <img src="/images/botox-face.png" alt="Mappa botox" draggable="false" />
                {punti.map((punto) => (
                    <div
                        key={punto.id}
                        className="injection-point"
                        style={{ left: punto.x + '%', top: punto.y + '%' }}
                        onClick={(e) => { e.stopPropagation(); handleRemovePunto(punto.id); }}
                        title={readOnly ? 'Punto iniezione' : 'Clicca per rimuovere'}
                    />
                ))}
            </div>
            <div className="botox-fields">
                {CAMPI_BOTOX.map((campo) => (
                    <div key={campo.key} className="botox-field-row">
                        <label>{campo.label}</label>
                        {readOnly ? (
                            <span className="botox-field-value">{valori[campo.key] || '___'}</span>
                        ) : (
                            <input
                                type="number"
                                step="0.1"
                                value={valori[campo.key] || ''}
                                onChange={(e) => handleValoreChange(campo.key, e.target.value)}
                                placeholder="___"
                            />
                        )}
                    </div>
                ))}
                <div className="botox-totale">
                    <label>TOTALE:</label>
                    <span>{totale}</span>
                </div>
            </div>
        </div>
    );
};

export default MappaBotox;
